import BaseReducer from "./BaseReducer";

class CustomerReviewModalReducer extends BaseReducer {
  domain = "CustomerInteractionReview";
  type = "Modal";

  initialState = {
    open: false,
    openStatusChangeModal: false,
    openCustomerReviewModal: false,
    openCustomerDetailsModal: false,
    currentTab: 1,
    tabs: [
      { id: 1, title: "Interactions" },
      { id: 2, title: "Linked Sessions" },
      { id: 3, title: "Reviews" },
    ],
    selectedCustomer: {
      id: null,
    },
    selectedSummaryRecord: null,
    selectedCustomerStatus: null,
    selectedCustomerSessions: [],
    sessionStats: null,
    customerStatus: null,
    records: [],
    reviewStatusIds: [1, 2, 3, 4, 5, 6, -1],
    reviewStatusCounts: [
        {
          color: "blue",
          disabled: false,
          key: 1,
          text: "Completed",
          quantity: 1,
        },
        {
          color: "red",
          disabled: false,
          key: 2,
          text: "Overdue",
          quantity: 1,
        },
        {
          color: "green",
          disabled: false,
          key: 3,
          text: "Due",
          quantity: 4,
        },
        {
          color: "orange",
          disabled: false,
          key: 4,
          text: "Not Due",
          quantity: 1,
        },
        {
          color: "grey",
          disabled: false,
          key: -1,
          text: "No Review",
          quantity: 1,
        },
        {
          color: "purple",
          disabled: false,
          key: 5,
          text: "In Progress",
          quantity: 1,
        },
        {
          color: "pink",
          disabled: false,
          key: 6,
          text: "Awaiting Approval",
          quantity: 1,
        }
    ],
    customerStatusOptions: [
      { text: "Normal", value: "isNormal" },
      {
        text: "Vulnerable Customer",
        value: "isVulnerable",
      },
      { text: "Temporary Break", value: "isTakingABreak" },
      { text: "Permanently Barred", value: "isBarred" },
    ],
    returnDate: null,
    interactionsColumns: [
      { name: "site", sortDirection: 1, label: "Site" },
      { name: "datetime", sortDirection: 1, label: "Date" },
      { name: "reason", sortDirection: 1, label: "Reason" },
      { name: "triggeredAlert", sortDirection: 1, label: "Triggered Alert?" },
      { name: "eventId", sortDirection: 1, label: "Event ID" },
    ],
    linkedSessionsColumns: [
      {
        name: "sessionGuid",
        sortDirection: 1,
        label: "Session ID",
      },
      { name: "gameTitle", sortDirection: 1, label: "Name" },
      { name: "manufacturer", sortDirection: 1, label: "Manufacturer" },
      { name: "date", sortDirection: 1, label: "Date" },
      { name: "time", sortDirection: 1, label: "Time" },
      { name: "netLoss", sortDirection: 1, label: "Net Loss" },
      { name: "duration", sortDirection: 1, label: "Duration" },
      { name: "site", sortDirection: 1, label: "Site" },
    ],
    reviewsColumns: [
      { name: "reviewStatus", sortDirection: 1, label: "Review Status" },
      { name: "reviewId", sortDirection: 1, label: "Review ID" },
      { name: "date", sortDirection: 1, label: "Date" },
      { name: "time", sortDirection: 1, label: "Time" },
      { name: "reviewTypeId", sortDirection: 1, label: "Review Type" },
    ],
  };
}

const reducer = new CustomerReviewModalReducer();

export default reducer;
